import React, { useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Breadcrumbs as BUIBreadcrumbs } from 'baseui/breadcrumbs';
import { Button } from 'baseui/button';
import { useStyletron } from 'baseui';
import _map from 'lodash/map';
import _filter from 'lodash/filter';

import { GLOBAL_THEME } from '../resources';
import { AppContext } from '../context';

const toSnakeCase = (inputString: string) => {
	return inputString
		.trim()
		.split('')
		.map((character, index) => {
			if (character === ' ') {
				return '_';
			}
			if (index !== 0 && character === character.toUpperCase()) {
				return `_${character.toLowerCase()}`;
			}
			return character;
		})
		.join('');
};

const useBreadcrumbs = () => {
	const location = useLocation();

	const { pathname } = location;
	const paths = pathname.split('/').map((path, idx, arr) => {
		const indexTillPathName = pathname.indexOf(path) + path.length;
		return {
			label: path.length === 0 ? 'HOME' : toSnakeCase(path).toUpperCase(),
			link: path.length === 0 ? '/' : pathname.substring(0, indexTillPathName),
			disabled: arr.length === idx + 1
		};
	});

	return { paths: _filter(paths, (path) => path.label !== 'LIST') };
};

const Breadcrumbs: React.FC<{}> = () => {
	const [css] = useStyletron();
	const { app } = useContext(AppContext);
	const { paths } = useBreadcrumbs();
	const history = useHistory();

	return (
		<div
			className={css({
				backgroundColor: GLOBAL_THEME.Colors.white,
				marginLeft: 0,
				height: '50px'
			})}>
			<div>
				{app && (
					<>
						<BUIBreadcrumbs>
							{_map(paths, (path) => {
								const { label, disabled, link } = path;
								if (disabled) {
									return (
										<span key={label} className={css({ padding: '14px 14px' })}>
											{label}
										</span>
									);
								}
								return (
									<Button onClick={() => history.push(link)} kind='tertiary' key={label}>
										{label}
									</Button>
								);
							})}
						</BUIBreadcrumbs>
					</>
				)}
			</div>
		</div>
	);
};

export default Breadcrumbs;
